import React from "react";
import { useNavigate } from "react-router-dom";

const API_SECONDARY = "#9564DD";

const PartnerFooter = () => {
  const navigate = useNavigate();

  return (
    <footer className="footer">
      <div className="footer-inner">

        <div className="footer-brand">

          <div className="footer-logo">
            C
          </div>

          <div>
            <strong>CertED Technologies</strong>

            <span>
              Connecting institutions, trainers and
              opportunities.
            </span>
          </div>

        </div>

        <div className="footer-links">

          <button
            type="button"
            onClick={() =>
              navigate("/partner-dashboard")
            }
          >
            Dashboard
          </button>

          <button
            type="button"
            onClick={() =>
              navigate("/partner/partner-jobs")
            }
          >
            My Jobs
          </button>

          <button
            type="button"
            onClick={() =>
              navigate("/partner/partner-notifications")
            }
          >
            Notifications
          </button>

        </div>

        <div className="copyright">
          © {new Date().getFullYear()} CertED Technologies
        </div>

      </div>

      <style>{`
        .footer {
          background: #17131d;
          color: white;
          margin-top: 20px;
        }

        .footer-inner {
          max-width: 1450px;
          min-height: 95px;
          margin: auto;
          padding: 20px 28px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 25px;
        }

        .footer-brand {
          display: flex;
          align-items: center;
          gap: 10px;
        }

        .footer-logo {
          width: 35px;
          height: 35px;
          border-radius: 8px;
          font-size: 17px;
          background: ${API_SECONDARY};
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: 800;
        }

        .footer-brand div:last-child {
          display: flex;
          flex-direction: column;
        }

        .footer-brand strong {
          font-size: 12px;
        }

        .footer-brand span {
          font-size: 9px;
          color: #aaa5ae;
          margin-top: 3px;
        }

        .footer-links {
          display: flex;
          gap: 18px;
        }

        .footer-links button {
          border: none;
          background: transparent;
          color: #bbb7bf;
          font-size: 10px;
          cursor: pointer;
        }

        .footer-links button:hover {
          color: white;
        }

        .copyright {
          color: #88838d;
          font-size: 9px;
        }

        @media (max-width: 650px) {
          .footer-inner {
            flex-direction: column;
            align-items: flex-start;
            padding: 22px 15px;
          }

          .footer-links {
            flex-wrap: wrap;
          }
        }
      `}</style>
    </footer>
  );
};

export default PartnerFooter;